var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"close-button shadow flex-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }